import React, {ReactElement, useEffect, useState} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {onAuthStateChanged} from "api/firebase";
import {
  appendIgnoreStandardRedirect,
  getRedirectPathAfterLogin,
} from "tools/routing";

const PublicRoute = ({children}: {children: ReactElement}): ReactElement => {
  const [state, setState] = useState({authorized: false});

  const location = useLocation();
  const redirectPath = getRedirectPathAfterLogin(location.search);

  useEffect(() => {
    return onAuthStateChanged((user) => {
      if (redirectPath) {
        setState({authorized: !!user});
      }
    });
  }, [redirectPath]);

  if (state.authorized && redirectPath) {
    const path = appendIgnoreStandardRedirect(redirectPath);
    return <Navigate to={path} />;
  }
  return children;
};

export default PublicRoute;
